import React, { useState, useEffect } from "react";
import api from "../api";
import CustomTextInput from "../components/CustomTextInput";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import CustomAutoComplete from "../components/CustomAutoComplete";
import GooglePlacesInput from "../components/GooglePlacesInput";
import DownloadIcon from "../components/icons/DownloadIcon";
import { GoogleMap, DirectionsRenderer } from "@react-google-maps/api";
import Spinner from "../components/Spinner";

export default function QuoterPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState("");
  const [date, setDate] = useState("");
  const [pickup, setPickup] = useState("");
  const [destination, setDestination] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [cars, setCars] = useState([]);
  const [car, setCar] = useState("");
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  const serviceTypeOptions = [
    { value: 1, label: "Un solo tramo" },
    { value: 2, label: "Varios tramos" },
    { value: 3, label: "Half Day" },
    { value: 4, label: "Full Day" },
    { value: 5, label: "Viaje de larga distancia dentro del país" },
    { value: 6, label: "Viaje al exterior" },
    { value: 7, label: "Tour" },
    { value: 8, label: "Solo chofer" },
    { value: 9, label: "Valet parking" },
  ];

  const mapContainerStyle = {
    width: "100%",
    height: 200,
    borderRadius: 15,
  };

  const calculateRoute = () => {
    if (!pickup || !destination) {
      console.log(pickup, destination);
      console.error("Faltan datos para calcular la ruta.");
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: pickup, // Dirección en texto
        destination: destination, // Dirección en texto
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirectionsResponse(result);
        } else {
          console.error("Error al calcular la ruta:", status);
        }
      }
    );
  };

  useEffect(() => {
    if (pickup && destination) {
      calculateRoute();
    }
  }, [pickup, destination]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        // Ejecutar ambas consultas en paralelo
        const [clientsResponse, carsResponse] = await Promise.all([
          api.clients.getMulti(),
          api.vehicles.getMulti(),
        ]);
        setClients(clientsResponse);
        setCars(carsResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        // Finalizar el estado de carga después de ambas consultas
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const handleFormSubmit = async (event) => {};

  const [opacityLevel, setOpacityLevel] = useState(0);

  useEffect(() => {
    if (loading) {
      let intervalId = setInterval(() => {
        setOpacityLevel((prev) => Math.min(prev + 0.1, 1)); // Incrementa la opacidad hasta 1
      }, 500); // Ajusta el intervalo para controlar la velocidad
      return () => clearInterval(intervalId); // Limpia el intervalo al desmontar
    } else {
      setOpacityLevel(1); // Asegúrate de que la opacidad esté al máximo al terminar de cargar
    }
  }, [loading]);

  return (
    <Layout>
      <div
        className={`p-8 space-y-10 bg-[#F8F9FB] transition-opacity ease-in-out`}
        style={{
          opacity: opacityLevel,
          transition: "opacity 0.5s linear",
        }}
      >
        <h1 className="poppins-bold text-lg text-[#1F384C] tracking-wider">
          Cotizador
        </h1>
        {loading ? (
          <Spinner />
        ) : (
          <div className="bg-white p-4 md:px-[280px] md:py-[95px]">
            <div className="flex flex-col gap-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <CustomAutoComplete
                    placeholder="Ingresa el nombre del cliente"
                    value={clientName}
                    onChange={setClientName}
                    options={clients}
                    valueKey="id" // Clave para el valor
                    labelKey="name" // Clave para el texto visible
                    //onAddNew={() => handleAddNew("client")}
                    isRequired
                  />
                  {fieldErrors.client && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.client[0]}
                    </p>
                  )}
                </div>
                <div>
                  <CustomTextInput
                    placeholder="Ingresa la fecha"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    isRequired
                  />
                  {fieldErrors.date && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.date[0]}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <GooglePlacesInput
                    value={pickup}
                    onChange={setPickup}
                    placeholder="Ingresa el lugar de recogida"
                  />
                  {fieldErrors.pickup && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.pickup[0]}
                    </p>
                  )}
                </div>
                <div>
                  <GooglePlacesInput
                    value={destination}
                    onChange={setDestination}
                    placeholder="Ingresa el lugar de destino"
                  />
                  {fieldErrors.destination && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.destination[0]}
                    </p>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <CustomTextInput
                    placeholder="Selecciona el tipo de traslado"
                    type="select"
                    value={serviceType}
                    onChange={(e) => setServiceType(e.target.value)}
                    options={serviceTypeOptions}
                    isRequired
                  />
                  {fieldErrors.serviceType && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.serviceType[0]}
                    </p>
                  )}
                </div>
                <div>
                  <CustomAutoComplete
                    placeholder="Selecciona el vehículo"
                    type="select"
                    value={car}
                    onChange={setCar}
                    options={cars}
                    labelKey="name"
                    valueKey="id"
                    //onAddNew={() => handleAddNew("car")}
                  />
                  {fieldErrors.vehicle && (
                    <p className="text-red-600 text-sm">
                      {fieldErrors.vehicle[0]}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <p className="poppins-regular py-[10px] text-[#8F99A6] tracking-wider text-xs">
                  Vista previa del recorrido
                </p>
                <div className="flex-grow rounded-md">
                  <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    options={{
                      fullscreenControl: true, // fullscreen button
                      zoomControl: false, // zoom controls
                      mapTypeControl: false, // map type control (Map/Satellite)
                      streetViewControl: false, // Street View control
                      scaleControl: false, // scale control
                    }}
                  >
                    {directionsResponse && (
                      <DirectionsRenderer directions={directionsResponse} />
                    )}
                  </GoogleMap>
                </div>
              </div>
            </div>

            <button
              className="w-full flex justify-center mt-10 py-3 px-5 border rounded-2xl shadow-sm text-sm text-white bg-[#BE202F] tracking-wider"
              onClick={() => {}}
            >
              Cotizar
            </button>
            <div className="flex justify-between mt-10">
              <div>
                <p className="poppins-regular text-[#8F99A6] tracking-wider text-xs">
                  Costo estimado
                </p>
                <p className="poppins-regular text-[#333333] tracking-wider text-[35px]">
                  Gs. 345.000{" "}
                </p>
              </div>
              <button
                className="poppins-medium flex items-center justify-center bg-[#D35B66] text-white text-xs py-4 px-4 rounded-2xl tracking-wider ml-auto"
                onClick={() => {}}
              >
                <div style={{ marginRight: 15 }}>
                  <DownloadIcon size={18} color="white" />
                </div>
                Generar PDF
              </button>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
